import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAnnouncements,
  selectCities,
  setAnnouncements,
  setCities,
  setTypeAnnouncement,
} from './jobSlice';
import { selectUserId } from '../Login/loginSlice';
import { getAnnouncements, getCities } from './jobApi';
import NewAnnouncement from './NewAnnouncement';
import './job.css';

const Job = () => {
  const dispatch = useDispatch();
  const announcements = useSelector(selectAnnouncements);
  const cities = useSelector(selectCities);
  const user_id = useSelector(selectUserId);

  const [showForm, setShowForm] = useState(false);
  const [filterAllMy, setFilterAllMy] = useState('all');
  const [filterType, setFilterType] = useState('v'); // v - вакансия, r - резюме
  const [filterJob, setFilterJob] = useState(2); // 2 - doc, 3 - tech
  const [selectedCity, setSelectedCity] = useState('Все');

  useEffect(() => {
    getAnnouncements({ filters: [] }, (data) => {
      dispatch(setAnnouncements(data.announcements));
    });
  }, [dispatch]);

  useEffect(() => {
    getCities({ filters: [] }, (data) => {
      dispatch(setCities(data.cities));
    });
  }, [dispatch]);

  const cityOptions = useMemo(() => ['Все', ...(cities || []).map((c) => c.name)], [cities]);

  const filtered = useMemo(() => {
    return (announcements || []).filter((a) => {
      if (a.type !== filterType) return false;
      if (selectedCity !== 'Все' && a.city !== selectedCity && (cities.find((x)=> x.id === a.city_id)?.name !== selectedCity)) return false;
      if (filterJob && a.profession_id !== filterJob) return false;
      return true;
    });
  }, [announcements, filterType, selectedCity, filterJob, cities]);

  const handleMy = () => {
    setFilterAllMy('my');
    getAnnouncements({ filters: 'my', user_id }, (data) => {
      dispatch(setAnnouncements(data.announcements));
    });
  };

  const handleAll = () => {
    setFilterAllMy('all');
    getAnnouncements({ filters: [] }, (data) => {
      dispatch(setAnnouncements(data.announcements));
    });
  };

  return (
    <div className="job-container">
      {showForm ? (
        <NewAnnouncement onClose={() => setShowForm(false)} />
      ) : (
        <div className="job-content">
          <div className="job-header">
            <h2 className="job-title">Объявления</h2>
            <button className="job-add" onClick={() => setShowForm(true)}>+ Новое</button>
          </div>

          <div className="job-filters">
            <div className="job-filter-group">
              <button className={filterType === 'r' ? 'btn-toggle active' : 'btn-toggle'} onClick={() => setFilterType('r')}>Ищу работу</button>
              <button className={filterType === 'v' ? 'btn-toggle active' : 'btn-toggle'} onClick={() => setFilterType('v')}>Ищу сотрудника</button>
            </div>

            <div className="job-filter-group">
              <select className="job-select" value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)}>
                {cityOptions.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            <div className="job-filter-group">
              <button className={filterAllMy === 'my' ? 'btn-outline active' : 'btn-outline'} onClick={handleMy}>Мои</button>
              <button className={filterAllMy === 'all' ? 'btn-outline active' : 'btn-outline'} onClick={handleAll}>Все</button>
            </div>
          </div>

          <div className="job-list">
            {filtered.map((a, idx) => (
              <div key={`${a.announcement_id || idx}`} className={a.type === 'v' ? 'job-card job-card-v' : 'job-card job-card-r'}>
                <div className="job-card-header">
                  <span className={a.type === 'v' ? 'badge badge-v' : 'badge badge-r'}>
                    {a.type === 'v' ? 'Требуется' : 'Ищу работу'}
                  </span>
                  <span className="prof">{a.profession_id === 2 ? 'Врач' : 'Техник'}</span>
                </div>
                <div className="job-card-row">
                  <span className="label">Город</span>
                  <span className="value">{a.city || cities.find((x)=> x.id === a.city_id)?.name || ''}</span>
                </div>
                <div className="job-card-row">
                  <span className="label">Тел.</span>
                  <span className="value phone">{a.phone}</span>
                </div>
                {a.comment?.trim() && (
                  <div className="job-card-comment">
                    <span className="label">Комментарий</span>
                    <p className="comment">{a.comment.trim()}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Job;
